export default __webpack_public_path__ + "static/media/fireworks.c3664257.png";